import { UserRealtimeSubscriptionItemDTO } from '../../types/realtime/UserRealtimeSubscriptionItemDTO';
import Checkbox from '../Forms/Input/Checkbox';

interface Props {
  channels: UserRealtimeSubscriptionItemDTO[];

  onToggle: (
    channelId: number,
    subscribed: boolean
  ) => void;
}

const RealtimeChannelList = ({
  channels,
  onToggle,
}: Props) => {
  return (
    <div className="space-y-3">
      {channels.map((channel) => (
        <div
          key={channel.channelId}
          className="
            hover:bg-gray-1
            flex
            items-start
            gap-4
            rounded-lg
            border
            border-stroke
            p-4
            transition
            dark:border-strokedark
            dark:hover:bg-meta-4
          "
        >
          <Checkbox
            checked={channel.subscribed}
            disabled={!channel.channelEnabled}
            onChange={() =>
              onToggle(
                channel.channelId,
                !channel.subscribed
              )
            }
          />

          <div className="flex-1">
            <div className="flex items-center gap-2">
              <span
                className="
                  font-medium
                  text-black
                  dark:text-white
                "
              >
                {channel.name}
              </span>

              {!channel.channelEnabled && (
                <span
                  className="
                    rounded-full
                    bg-danger
                    bg-opacity-10
                    px-2
                    py-0.5
                    text-xs
                    font-medium
                    text-danger
                  "
                >
                  Deshabilitado
                </span>
              )}
            </div>

            <div
              className="
                mt-1
                text-xs
                text-primary
              "
            >
              {channel.code}
            </div>

            <div
              className="
                mt-1
                text-sm
                text-body
                dark:text-bodydark
              "
            >
              {channel.description}
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default RealtimeChannelList;